import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";

export const HtmlPreview = ({ show, toggle, htmlData }) => {
  const { t } = useTranslation();

  return (
    <Modal
    size="xl"
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("common.button.preview")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="preview-html">
          <div
            dangerouslySetInnerHTML={{
              __html: htmlData,
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={toggle}>
          {t("common.button.close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
